import React from 'react'
import { FieldTemplate } from 'types/core/field-template'
import { Props, PropValue } from 'types/core/props'
import Button from '../Button'
import Modal from '../Modal'

import classes from './style.module.css'
import { validateTaxNumberRu } from '../../../lib/shared/validation/tax-number'

interface MonitoringCompanyFormProps {
  isVisible: boolean
  isLoading: boolean
  template: {
    fields: FieldTemplate[]
  }
  formData: Props
  onChange: (value: PropValue, id: string) => void
  onSubmit: () => void
  onClose: () => void
  header?: string
}

const MonitoringCompanyForm: React.FC<MonitoringCompanyFormProps> = ({
  isVisible,
  isLoading,
  template,
  formData,
  onChange,
  onSubmit,
  onClose,
  header = 'Форма',
}) => {
  const [error, setError] = React.useState<string | null>(null)

  const renderField = (field: FieldTemplate) => {
    const currentValue = formData[field.name] ?? field.defaultValue

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      setError(null)
      const { value } = e.target

      // Разрешаем только цифры и обрезаем до 12 символов
      if (/^\d*$/.test(value) && value.length <= 12) {
        onChange(value, field.name)
      }

      if (!validateTaxNumberRu(value)) {
        setError('Некорректный формат ИНН')
      }
    }

    return (
      <div className={classes.fieldGroup}>
        <label htmlFor={field.name}>{field.title}</label>
        <input
          id={field.name}
          type="text"
          inputMode="numeric"
          maxLength={12}
          value={currentValue as string}
          onChange={handleInputChange}
          placeholder={field.example}
        />
        {error && <div className={classes.errorText}>{error}</div>}
      </div>
    )
  }

  return (
    <Modal isOpen={isVisible} handleClose={onClose} header={header}>
      <div className={classes.modalContent}>
        {template.fields.map((field) => (
          <div key={field.name} style={{ marginBottom: '0.5rem' }}>
            {renderField(field)}
          </div>
        ))}

        <div className="d-flex justify-content-end w-100" style={{ padding: '4px' }}>
          <Button isLoading={isLoading} onClick={onSubmit} content="Сохранить" disabled={error !== null} />
        </div>
      </div>
    </Modal>
  )
}

export default MonitoringCompanyForm
